import { useState } from 'react';

const makeNewGUID = () => {
  if (window.__guidCounter == null) {
    window.__guidCounter = 0;
  }
  return ++window.__guidCounter;
};

const useGUID = (props) => {
  const [guid] = useState(makeNewGUID());
  return guid;
};

export default useGUID;
